var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Id, config, content } from "core/utils";
import React from "react";
import { BoxCoverCollection } from "core/components/BoxCoverCollection";
export var View = function (_a) {
    var items = _a.items;
    return (React.createElement(BoxCoverCollection, __assign({ componentId: Id.component.contentCollection.movies, collectionComponentId: Id.component.contentCollection.movies, listName: config.tracking.listNames.movies, title: content.title.movies, trackingEnabled: true }, { items: items })));
};
